import {hasValue} from '@famly/stat_ts-utils_has-value';

import ENV from './environment';
import {type Whitelabel, getConfig} from './white-labeling-constants';
import whitelabelConfigs from '../../whitelabel/whitelabel-config.json';

export const OVERRIDE_WHITE_LABEL_KEY = 'famly.OVERRIDE_WHITE_LABEL_KEY';

let _determinedWhitelabel: Whitelabel | null | undefined;

const determineWhitelabel = () => {
    const overriddenWhitelabel = window.sessionStorage?.getItem(OVERRIDE_WHITE_LABEL_KEY);

    if (hasValue(overriddenWhitelabel) && isValidWhitelabelKey(overriddenWhitelabel)) {
        return overriddenWhitelabel as Whitelabel;
    }
    const isWhitelabel = whitelabels.find(whitelabel => {
        return window.location.host.endsWith(getConfig(whitelabel, 'domain')) || ENV.WHITELABEL_APP_ID === whitelabel;
    });

    if (isWhitelabel) {
        return isWhitelabel;
    }
    return null;
};

export const whitelabels = Object.keys(whitelabelConfigs) as Whitelabel[];

const isValidWhitelabelKey = (whitelabel: string) => {
    return whitelabels.includes(whitelabel as any);
};

export const getWhitelabel = () => {
    if (_determinedWhitelabel !== undefined) {
        return _determinedWhitelabel;
    } else {
        const whitelabel = determineWhitelabel();
        _determinedWhitelabel = whitelabel;
        return _determinedWhitelabel;
    }
};

export const overrideWhitelabel = (whitelabelKey: string) => {
    if (!isValidWhitelabelKey(whitelabelKey)) {
        return;
    }

    window.sessionStorage.setItem(OVERRIDE_WHITE_LABEL_KEY, whitelabelKey);
};

/**
 * These ids maps to how the backend configures push notifications.
 * We send this ID along with the push notification token when we register the app installation
 * for push notifications in the backend.
 *
 * When inserting new whitelabel apps, generate a random UUID, and communicate that to the backend
 * that's responsible for configuring the push notifications.
 */
export const getWhitelabelPushAppId = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        const pushAppId = getConfig(whitelabel, 'pushAppId') as string;

        if (pushAppId) {
            return pushAppId;
        }
    }
    return getConfig('famly', 'pushAppId') as string;
};

/**
 * The value returned from this is used wherever we mention the "product name".
 */
export const getWhitelabelName = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        return getConfig(whitelabel, 'title') as string;
    }
    return 'Famly';
};

export const getWhitelabelUrl = () => {
    const whitelabel = getWhitelabel();
    return whitelabel ? (getConfig(whitelabel, 'domain') as string) : null;
};

export const getWhitelabelMobileAppUrl = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        return getConfig(whitelabel, 'app_url_scheme') as string;
    }
    return getConfig('famly', 'app_url_scheme') as string;
};

export const isWhitelabelRingfenced = () => {
    const whitelabel = getWhitelabel();

    if (whitelabel === null) {
        return false;
    }

    return Boolean(getConfig(whitelabel, 'isRingfenced'));
};
